<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                @for (option of options; track option) {
                  <checkbox-container
                    [ngClass]="{
                      'container-checked': product
                        ?.get('parameters')
                        ?.get(option.formControlName)?.value,
                    }"
                  >
                    <pr-input-checkbox
                      [derrors]="derrors"
                      [formControlName]="option.formControlName"
                      [label]="option.label"
                    >
                      @if (option?.description) {
                        <p class="description">
                          {{ option?.description }}
                        </p>
                      }
                      @if (
                        option?.input &&
                        product?.get('parameters')?.get(option.formControlName)
                          ?.value
                      ) {
                        <pr-input-column
                          [derrors]="derrors"
                          [isDefault]="false"
                        >
                          <input
                            (focus)="select(option)"
                            [formControlName]="option.input.formControlName"
                            type="number"
                          />
                          @if (
                            option.input.formControlName !=
                            'additionalPropertyNumber'
                          ) {
                            <i>€</i>
                          }
                        </pr-input-column>
                      }
                      @if (option?.displayValue) {
                        <p class="displayValue">
                          {{
                            (product
                              ?.get('parameters')
                              ?.get(option.hardFormControlName)?.value || '') +
                              '' +
                              option?.displayValue
                          }}
                        </p>
                      }
                    </pr-input-checkbox>
                  </checkbox-container>
                }
                <!-- <div
                class="col-md-6 mt"
                style="max-height: 160px; min-height: 160px"
                *ngFor="let option of options"
                >
                <pr-input-checkbox
                  [derrors]="derrors"
                  [formControlName]="option.formControlName"
                  label=""
                  [withBox]="true"
                  >
                  <card
                    [checked]="product.get(option.formControlName)?.value"
                    [title]="option.label"
                    >
                    <ng-container *ngIf="option?.description">
                      <div class="description">
                        {{ option?.description }}
                      </div>
                    </ng-container>
                    <ng-container *ngIf="option?.input">
                      <div class="d-flex">
                        <pr-input-column
                          [derrors]="derrors"
                          [isDefault]="false"
                          >
                          <input
                            (focus)="select(option)"
                            [formControlName]="option.input.formControlName"
                            type="number"
                            min="0"
                            />
                        </pr-input-column>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="option?.displayValue">
                      <div class="displayValue">
                        {{
                        product.get(option.hardFormControlName)?.value +
                        "" +
                        option?.displayValue
                        }}
                      </div>
                    </ng-container>
                  </card>
                </pr-input-checkbox>
              </div> -->
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
